import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebOrderDto } from '../Model/web-order-dto';
import { DeliveryFeedBack } from '../Model/delivery-feed-back';
import { Observable } from 'rxjs';
import { PaymentHistoryDto } from '../Model/payment-history-dto';

@Injectable({
  providedIn: 'root'
})
export class InvoiceHistoryService {

  constructor(
    private http: HttpClient
  ) { }

  getWebOrderDetailsByLoggedInUser(url: string, customerEmail: string, currentUrl: string) {
    return this.http.get<WebOrderDto[]>(url + "/" + customerEmail + "/" + currentUrl);
  }

  insertFeedBack(url: string, req: DeliveryFeedBack[]): Observable<any> {
    return this.http.post(url, req, { responseType: "text" });
  }

  getWebOrderPaymentHistory(url: string, customerEmail: string, ordNoStartsWith: string) {
    return this.http.get<PaymentHistoryDto[]>(url + "/" + customerEmail + "/" + ordNoStartsWith);
  }
}